import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back ✨");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not log in");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-narrow py-20 grid lg:grid-cols-2 gap-12 items-center" data-testid="login-page">
      <div className="hidden lg:block">
        <div className="label-eyebrow mb-3">Welcome back</div>
        <h1 className="font-heading text-5xl font-semibold leading-tight mb-4">
          The workshop is <span className="italic text-marigold">still warm</span>.
        </h1>
        <p className="text-ink2 max-w-md">
          Pick up where you left off — your saved blueprints, lesson progress, and the little
          half-finished app you were sketching last Tuesday.
        </p>
      </div>
      <form onSubmit={submit} className="card-soft p-8 max-w-md w-full mx-auto" data-testid="login-form">
        <h2 className="font-heading text-2xl font-semibold mb-6">Log in</h2>
        <label className="text-sm font-medium block mb-1">Email</label>
        <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="input-soft mb-4" data-testid="login-email" />
        <label className="text-sm font-medium block mb-1">Password</label>
        <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="input-soft mb-3" data-testid="login-password" />
        <div className="mb-6 text-right">
          <Link to="/forgot-password" className="text-xs text-ink2 hover:text-marigold hover:underline" data-testid="login-forgot-link">
            Forgot password?
          </Link>
        </div>
        <button className="btn-primary w-full justify-center" disabled={busy} data-testid="login-submit">
          {busy ? "Logging in…" : "Log in"}
        </button>
        <p className="text-sm text-ink2 mt-5 text-center">
          New here? <Link to="/signup" className="text-marigold font-medium" data-testid="login-to-signup">Create an account</Link>
        </p>
      </form>
    </div>
  );
}
